interface AppLogoProps {
  className?: string;
}

export const AppLogo = ({ className }: AppLogoProps) => {
  return (
    <div className={`flex items-center gap-2 ${className ?? ""}`}>
      <img
        src="/arsoc-icon.png"
        alt="Arsoc"
        className="h-8 w-8 rounded object-contain"
      />
      <span className="text-xl font-bold" style={{ color: "hsl(213 65% 25%)" }}>
        Arsoc
      </span>
    </div>
  );
};
